.button {
  display: inline-flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  justify-content: center;
  min-inline-size: var(--control-md);
  block-size: var(--control-md);
  padding-inline: var(--space-3);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  color: var(--color-text);
  font-size: var(--text-md);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);
  text-decoration: none;
  white-space: nowrap;
  cursor: default;
  user-select: none;
  transition:
    background-color var(--duration-fast) ease,
    border-color var(--duration-fast) ease,
    color var(--duration-fast) ease,
    transform var(--duration-fast) var(--easing-standard);
}

.button:hover {
  color: var(--color-text);
}

@media (hover: hover) and (pointer: fine) {
  .button:hover:not([data-disabled]) {
    background: var(--color-surface-hover);
  }
}

.button:active:not([data-disabled]) {
  background: var(--color-surface-active);
  transform: scale(var(--motion-scale));
}

.button[aria-busy="true"] {
  cursor: progress;
}

.button[data-size="sm"] {
  min-inline-size: var(--control-sm);
  block-size: var(--control-sm);
  padding-inline: var(--space-2);
  font-size: var(--text-sm);
}

.button[data-size="lg"] {
  min-inline-size: var(--control-lg);
  block-size: var(--control-lg);
  padding-inline: var(--space-4);
}

.button[data-icon-only] {
  padding-inline: 0;
}

/* Primary: the one solid accent action of a view. */
.button[data-variant="primary"] {
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: var(--color-accent-contrast);
}

@media (hover: hover) and (pointer: fine) {
  .button[data-variant="primary"]:hover:not([data-disabled]) {
    border-color: var(--color-accent-hover);
    background: var(--color-accent-hover);
    color: var(--color-accent-contrast);
  }
}

.button[data-variant="primary"]:active:not([data-disabled]) {
  background: var(--color-accent-hover);
}

.button[data-variant="primary"][aria-busy="true"] {
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: var(--color-accent-contrast);
}

/* Ghost: toolbars, row actions and low-emphasis actions. */
.button[data-variant="ghost"] {
  border-color: transparent;
  background: transparent;
}

/* Danger: destructive confirmations (AlertDialog). */
.button[data-variant="danger"] {
  border-color: var(--color-danger);
  background: var(--color-danger);
  color: var(--color-text-inverse);
}

@media (hover: hover) and (pointer: fine) {
  /* Mixing toward --color-text darkens in light themes and lightens in dark, like accent-10. */
  .button[data-variant="danger"]:hover:not([data-disabled]) {
    border-color: color-mix(in oklab, var(--color-danger) 88%, var(--color-text));
    background: color-mix(in oklab, var(--color-danger) 88%, var(--color-text));
    color: var(--color-text-inverse);
  }
}

/* Disabled wins over every variant; a pending button keeps its variant look. */
.button[data-disabled]:not([aria-busy="true"]) {
  border-color: var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-subtle);
}

.button[data-variant="ghost"][data-disabled]:not([aria-busy="true"]) {
  border-color: transparent;
  background: transparent;
}

.fullWidth {
  inline-size: 100%;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}
